/* Model */
class SizeAliasModel extends App.Models.BaseModel {
    modelUrl = 'SizeAlias';
}

App.Models.SizeAlias = SizeAliasModel;

/* Collection */
class SizeAliasCollection extends App.Collections.BaseCollection {
    url = 'SizeAlias';
    model = App.Models.SizeAlias;
}

App.Collections.SizeAliass = SizeAliasCollection;

/* Router */
class SizeAliasRouter extends App.Routers.BaseRouter {

    iconOptions = [
        'gmfont-sizes-icon-size1',
        'gmfont-sizes-icon-size2',
        'gmfont-sizes-icon-size3',
        'gmfont-sizes-icon-volume1',
        'gmfont-sizes-icon-volume2',
        'gmfont-sizes-icon-liquid',
        'gmfont-sizes-icon-circle',
        'gmfont-sizes-icon-rect',
        'gmfont-sizes-icon-blocks',
        'gmfont-sizes-icon-box',
        'gmfont-sizes-icon-boxes',
        'gmfont-sizes-icon-bottle',
        'gmfont-sizes-icon-bottles',
        'gmfont-sizes-icon-can',
        'gmfont-sizes-icon-cans',
        'gmfont-sizes-icon-basket',
        'gmfont-sizes-icon-cart',
        'gmfont-sizes-icon-case',
        'gmfont-sizes-icon-cilinders',
        'gmfont-sizes-icon-cube',
        'gmfont-sizes-icon-dollar',
        'gmfont-sizes-icon-formula',
        'gmfont-sizes-icon-totals',
        'gmfont-sizes-icon-value',
        'gmfont-sizes-icon-barrel',
        'gmfont-sizes-icon-gasKeg',
        'gmfont-sizes-icon-keg',
        'gmfont-sizes-icon-lock',
        'gmfont-sizes-icon-people',
        'gmfont-sizes-icon-weight',
        'gmfont-sizes-icon-weights',
        'gmfont-sizes-icon-bag',
        'gmfont-sizes-icon-paperBag'
    ];

    constructor() {
        const entityName = 'SizeAlias';
        const model = App.Models.SizeAlias;
        const collectionClass = App.Collections.SizeAliass;

        super(entityName, model, collectionClass);
    }
}

App.Routers.SizeAlias = SizeAliasRouter;
